import React from "react";
import "./ChatMasterContainerStyles.css"; // Assuming you have a CSS file for styles
interface ChatMasterContainerProps extends React.PropsWithChildren {}
function ChatMasterContainer(props: ChatMasterContainerProps) {
  const { children } = props;
  return <div className="chat-layout-master">{children}</div>;
}

export default ChatMasterContainer;
